export const deleteTableItems = (key, uuids, { data, setData }) => {
  const newData = data.items.filter((item) => !uuids.includes(item[key]));
  const merged = {
    ...data,
    items: newData,
    metadata: {
      ...data.metadata,
      count: newData.length,
    },
  };

  setData(merged);
};
